export const QUOTE_MAX_DOCUMENT_SIZE = 10 * 1024 * 1024; // 10 Mb
export const QUOTE_MAX_NOTE_LENGTH = 1024;
export const QUOTE_DOCUMENT_TYPES = ['.pdf', '.xls', '.xlsx', '.doc', '.docx', '.ppt', '.pptx', '.jpg', '.jpeg', '.dxf', '.png', '.svg', '.csv'];
export const PURCHASE_ORDER_DOCUMENT_TYPES = ['.pdf', '.jpg', '.jpeg', '.png'];
export const COUNTERTOP_GROUPS = ["Backsplash", "Center Island Countertop", "Countertop"];
export const JOB_DOCUMENT_TYPES = {
  invoice: "invoice",
  order: "order",
};
